import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import Form from "@common/externos/components/validation/form.validation";
import decaActions from "../store/deca.actions";
import decaSelector from "../store/deca.selectors";
import solicitacaoSelector from "../components/solicitacao/store/solicitacao.selectors";
import documentoSelector from "../components/documentos/store/documento.selectors";
import autoBind from "react-autobind";

//Subforms
import Solicitacao from "../components/solicitacao/container/solicitacao.subform";
import DadosSolicitante from "../components/dadosSolicitante/container/dadosSolicitante.subform";
import EnderecoPrincipal from "../components/enderecoPrincipal/container/enderecoprincipal.subform";
import EnderecoCobranca from "../components/enderecoCobranca/container/enderecocobranca.subform";
import Cnae from "../components/cnae/container/cnae.subform";
import Atividades from "../components/atividades/container/atividades.subform";
import Documentos from "../components/documentos/container/documentos.subform";
import Historicos from "../components/historico/container/historicos.subform";
import Socio from "../components/socio/container/socio.subform";

import comprovanteSolicitacaoActions from "../components/comprovante/store/comprovanteSolicitacao.actions";
import comprovanteSolicitacaoSelector from "../components/comprovante/store/comprovanteSolicitacao.selectors";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  get initialValues() {
    return {};
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "DECA" });
  }

  onPrint() {
    const { routerManager, comprovanteSolicitacaoActions } = this.props;
    const { id } = routerManager.params;
    comprovanteSolicitacaoActions.getImprimirComprovante(id);
  }

  disableAll() {
    const { solicitacao } = this.props.solicitacaoSelector;

    return (
      solicitacao.SituacaoSolicitacao != 1 &&
      solicitacao.SituacaoSolicitacao != 2 &&
      solicitacao.SituacaoSolicitacao != 8
    );
  }

  render() {
    const { onSubmit, onCancel } = this.props;
    const { documento } = this.props.documentoSelector;
    const { anexo, anexoCustomizado } = documento;
    const disableAll = this.disableAll();
    const { solicitacao } = this.props.solicitacaoSelector;
    const { deca: decaState } = decaSelector;

    if (decaState.typeDeca == 1 && decaState.loadDeca == 1) return <></>;

    const encerramentoDesabilita = disableAll
      ? true
      : solicitacao.CCM != undefined && solicitacao.TipoSolicitacaoNumero == 3;

    let contemAnexo = anexo?.length > 0;
    let contemAnexoCustomizado = anexoCustomizado?.length > 0;

    return (
      <>
        <Form
          onSubmit={!disableAll ? onSubmit : null}
          onCancel={onCancel || this.onCancel}
          initialValues={this.initialValues}
          onPrint={this.onPrint}
        >
          {(form) => (
            <Fragment>
              <Solicitacao
                form={form}
                prefix="R"
                disableAll={disableAll}
                disableAllDadosCadastrais={disableAll}
                retificarDadosCadastrais={true}
              />

              <EnderecoPrincipal
                form={form}
                disableAll={disableAll || encerramentoDesabilita}
              />
              <EnderecoCobranca
                form={form}
                disableAll={disableAll || encerramentoDesabilita}
              />
              <Socio
                form={form}
                disableAll={disableAll || encerramentoDesabilita}
              />
              <Cnae
                form={form.values.Cnae}
                disableAll={disableAll || encerramentoDesabilita}
              />
              <Atividades
                form={form.values.SuggestionAtividade}
                disableAll={disableAll || encerramentoDesabilita}
              />
              {(contemAnexo || contemAnexoCustomizado) && (
                <Documentos
                  form={form}
                  anexos={this.anexo}
                  disableAll={disableAll}
                />
              )}

              <DadosSolicitante form={form} disableAll={disableAll} />
              <Historicos form={form} disableAll={disableAll} />
            </Fragment>
          )}
        </Form>
      </>
    );
  }
}

export default connect({
  actions: {
    decaActions,
    comprovanteSolicitacaoActions,
  },
  selectors: {
    decaSelector,
    documentoSelector,
    solicitacaoSelector,
    comprovanteSolicitacaoSelector,
  },
})(Container);
